import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-column-box new-video-right-wrap" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "text-list-wrap"
}
const _hoisted_5 = {
  key: 0,
  class: "tips"
}
const _hoisted_6 = {
  key: 3,
  class: "text-list-wrap"
}
const _hoisted_7 = { style: {"font-size":"12px"} }
const _hoisted_8 = {
  key: 0,
  class: "tips"
}

import { ref } from 'vue';
import Broadcast from './broadcast.vue';
import Textstyle from './textstyle.vue';
import { getAppChatHistoryRecordPage } from '@/request/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'toolBar',
  props: {
  clearFlag: {
    type: Number,
    default: 0,
  },
  broadcastContent: {
    type: String,
    default: '',
  },
  digitalMan: {
    type: Object,
    default: () => ({}),
  },
  detail: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['sourceChange', 'generateVideo'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const broadCastRef = ref();
const props = __props;

const tabs = [
  {
    label: '播报内容',
    value: 1,
  },
  /* {
    label: '字幕样式',
    value: 2
  } */
  /* {
    label: 'AI生成记录',
    value: 3,
  }, */
  {
    label: 'AI历史文案',
    value: 4,
  }
];

const activeTab = ref(1);
const toggleTab = (tab) => {
  activeTab.value = tab;
};

const textChange = (val, duration) => {
  emits('sourceChange', 5, val, duration);
};

const urlChange = (val) => {
  emits('sourceChange', 7, val);
};

const timbreChange = (val) => {
  emits('sourceChange', 8, val);
};

const aiHistoryLists = ref([]);

const teamAiHistoryLists = ref([]);
const getTeamAiHistoryLists = () => {
  getAppChatHistoryRecordPage({
    pageIndex: 1,
    pageSize: 100
  }).then(res => {
    const { data } = res.data;
    teamAiHistoryLists.value = data.list;
  })
}
getTeamAiHistoryLists();
const textContentChange = (val) => {
  aiHistoryLists.value.push(val);
  emits('sourceChange', 9, val);
};

const projectIdChange = (val) => {
  emits('sourceChange', 12, val);
};

const playbackRateChange = (val) => {
  emits('sourceChange', 13, val);
};

const multilingualChange = (val) => {
  emits('sourceChange', 15, val);
};

const onNavChange = (val) => {
  emits('sourceChange', 16, val);
};

const aiGenerateWordChange = (val) => {
  emits('sourceChange', 22, val);
}

const generateVideo = (val) => {
  emits('generateVideo');
}

// const textStyleChange = ($event) => {
//   // console.log($event.color);
//   if($event) emits('sourceChange', 6, $event);
// }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("a", {
          class: _normalizeClass(activeTab.value == tab.value && 'active'),
          onClick: ($event: any) => (toggleTab(tab.value))
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    (activeTab.value == 1)
      ? (_openBlock(), _createBlock(Broadcast, {
          key: 0,
          ref_key: "broadCastRef",
          ref: broadCastRef,
          clearFlag: props.clearFlag,
          broadcastContent: __props.broadcastContent,
          detail: __props.detail,
          digitalMan: __props.digitalMan,
          onChange: textChange,
          onUrlChange: urlChange,
          onTimbreChange: timbreChange,
          onTextContentChange: textContentChange,
          onProjectIdChange: projectIdChange,
          onMultilingualChange: multilingualChange,
          onPlaybackRateChange: playbackRateChange,
          onOnNavChange: onNavChange,
          onAiGenerateWordChange: aiGenerateWordChange,
          onGenerateVideo: generateVideo
        }, null, 8, ["clearFlag", "broadcastContent", "detail", "digitalMan"]))
      : _createCommentVNode("", true),
    (activeTab.value == 2)
      ? (_openBlock(), _createBlock(Textstyle, {
          key: 1,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.textStyleChange($event)))
        }))
      : _createCommentVNode("", true),
    (activeTab.value == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiHistoryLists.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_input, {
              value: item,
              type: "textarea",
              rows: 6,
              class: "text-wrap",
              readonly: ""
            }, null, 8, ["value"]))
          }), 256)),
          (aiHistoryLists.value.length == 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "暂无历史记录"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (activeTab.value == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamAiHistoryLists.value, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(item.createTime) + " " + _toDisplayString(item.nickname) + "(" + _toDisplayString(item.teamName) + ")", 1),
              _createElementVNode("p", null, "描述信息: " + _toDisplayString(item.inputContent), 1),
              _createVNode(_component_el_input, {
                value: item.chatContent,
                type: "textarea",
                rows: 6,
                class: "text-wrap",
                readonly: ""
              }, null, 8, ["value"])
            ]))
          }), 256)),
          (teamAiHistoryLists.value.length == 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "暂无团队文案"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})